// extracted by mini-css-extract-plugin
export default {"pagination":"Paginacion_pagination__9zDB8","pageButton":"Paginacion_pageButton__MHPWd","active":"Paginacion_active__NNxr-"};